module.exports = __webpack_public_path__ + "static/media/bv-logo.78657d4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bv-logo.svg
// module id = 1642
// module chunks = 20